import * as React from 'react'
// api
import {  AlarmDetailsDto, useGetActiveObjectAlarmsQuery, sort as alarmSort } from '../../services/alarm'

interface UseObjectAlarmsOutput {
    count: number,
    items: AlarmDetailsDto[] | undefined,
    error: any,
    isLoading: boolean
}

function useObjectAlarms(objectId: string, resourceGroupId: string, includeChildren?: boolean): UseObjectAlarmsOutput {

    const { data: alarms, error, isLoading} = useGetActiveObjectAlarmsQuery({objectId,resourceGroupId, includeChildren: includeChildren ?? false}, { skip: !objectId || !resourceGroupId});

    const objectAlarms = React.useMemo(() => {
        //console.debug("useObjectAlarms(): alarms changed " + objectId);
        return alarms?.slice().sort((a, b) => alarmSort(a, b))
    }, [alarms]);


    return {
        count: objectAlarms?.length || 0,
        items: objectAlarms,
        error: error,
        isLoading: isLoading
    }
}

export default useObjectAlarms